import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface InvestorSlide14Props {
  isDark?: boolean;
}
export function InvestorSlide14({
  isDark = false
}: InvestorSlide14Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-226">
      <div className="min-h-full flex flex-col justify-center items-center max-w-4xl mx-auto px-4 sm:px-8 py-16 sm:py-20 text-center" data-id="element-227">
        <motion.h1 variants={itemVariants} className={`text-3xl sm:text-5xl font-bold mb-8 sm:mb-10 leading-tight px-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-228">
          "Every people leader deserves the support to lead sustainably."
        </motion.h1>

        <motion.p variants={itemVariants} className={`text-lg sm:text-2xl mb-12 sm:mb-16 max-w-3xl leading-relaxed px-4 ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-229">
          Leadership wellness isn't a perk—it's infrastructure.
          <br data-id="element-230" />
          <span className={`font-semibold ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-231">
            We're building the category leader.
          </span>
        </motion.p>

        <motion.a variants={itemVariants} href="https://calendly.com/abrahamadvocate/short-heliona-demo" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 sm:gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-heliona-mint hover:bg-heliona-mint-dark text-heliona-navy font-semibold text-base sm:text-lg rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-232">
          Schedule a Meeting
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-233" />
        </motion.a>
      </div>
    </motion.div>;
}